import { useMutation, useQuery } from "@tanstack/react-query";
import { 
  PasswordResetService, 
  PasswordResetRequestDTO, 
  PasswordResetDTO,
  TokenValidationResponse 
} from "../services/PasswordService";

/**
 * Hook para solicitar a recuperação de senha
 */
export const usePasswordResetRequest = () => {
  return useMutation({
    mutationFn: (data: PasswordResetRequestDTO) => PasswordResetService.requestReset(data)
  });
};

/**
 * Hook para validar o token de recuperação de senha
 */
export const useValidateResetToken = (token: string | null) => {
  return useQuery<TokenValidationResponse>({
    queryKey: ['validate-reset-token', token],
    queryFn: async () => {
      if (!token) {
        return { 
          success: false, 
          message: 'Token é obrigatório',
          data: undefined
        } as TokenValidationResponse;
      }

      try {
        console.log('[useValidateResetToken] Validando token JWT:', token.substring(0, 30) + '...');
        // Usar o método validateToken apenas com o token JWT
        const response = await PasswordResetService.validateToken(token);
        console.log('[useValidateResetToken] Resposta da validação:', response);
        
        // Garantir que a resposta está no formato esperado
        return {
          success: response.success,
          message: response.message,
          data: response.data
        } as TokenValidationResponse;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        console.error('[useValidateResetToken] Erro ao validar token JWT:', error);
        return {
          success: false,
          message: error.message || 'Erro ao validar token de recuperação',
          data: undefined
        } as TokenValidationResponse;
      }
    },
    enabled: !!token, // Só executa a consulta se token não for nulo
    retry: false, // Não tenta novamente em caso de falha
    staleTime: 0, // Sempre busca dados novos
    refetchOnWindowFocus: false, // Não re-consulta ao focar na janela
  });
};

/**
 * Hook para redefinir a senha do usuário
 */
export const useResetPassword = () => {
  return useMutation({
    mutationFn: (data: PasswordResetDTO) => PasswordResetService.resetPassword(data)
  });
};
